// @ts-expect-error untyped module

// @ts-expect-error untyped module

// for redesigned filters component

// Used for `segmentCriteria` and `goalCriteria`

// from the trigger selection panel, may not represent enroll types on the BE
const TriggerTypeOptionValues = ['LIST', 'EVENT', 'SCHEDULED', 'WEBHOOK', 'DATASET'];
export const isTriggerTypeOption = value => {
  return TriggerTypeOptionValues.includes(value);
};
export const WEBHOOK_SELECTION = 'WEBHOOK_SELECTION';
export const DATASET_SELECTION = 'DATASET_SELECTION';
const ENROLLMENT_REVIEW = 'ENROLLMENT_REVIEW';